import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import CustomCard from '../../../v2-components/Antd/Card';
import { CustomNotification } from '../../../v2-components/Notification';
import { Notification } from '../../../v2-components/Notification/constant';
// import MercadoPagoIntegration from '../components/MercadoPagoIntegration';
import PharmacyLocalForm from '../components/PharmacyLocalForm';
import { Service } from '../service';
import { capitalizeWords } from './handle/capitalize-words.handle';
import { checkRol } from './handle/check-rol.handle';
import Loading from '../../../v2-components/Loading';
import './style.scss';

export default function PharmacyLocalsDetailsPage() {
	const [data, setData] = useState();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState();
	const { id } = useParams();
	const [regionOptions, setRegionOptions] = useState([]);
	// const [mercadoPagoData, setMercadoPagoData] = useState(null);
	// const [nameLocal, setNameLocal] = useState(data?.name_local);
	const [communesOptiones, setCommunesOptiones] = useState([]);

	useEffect(() => {
		Promise.all([new Service().getById(id), new Service().getRegionsByCountry()])
			.then(([pharmacyResponse, regionsResponse]) => {
				setData(pharmacyResponse);
				const options = regionsResponse.map((region) => ({ label: region, value: region }));
				setRegionOptions(options);
				setLoading(false);
				// setNameLocal(pharmacyResponse?.name_local);
			})
			.catch((e) => {
				console.log(e);
				setError(true);
			});
	}, [id]);

	// useEffect(() => {
	// 	new Service()
	// 		.getPharmacieMP(nameLocal)
	// 		.then((response) => {
	// 			setMercadoPagoData(response);
	// 		})
	// 		.finally(() => setLoading(false));
	// }, [nameLocal]);

	const handleOnFinish = async (updatedPharmacyLocal) => {
		new Service()
			.updateById(id, updatedPharmacyLocal)
			.then((response) => {
				setData(response);
				CustomNotification({ type: Notification.type.success, message: Notification.message.success, description: 'Actualizado con éxito' });
			})
			.catch((e) => {
				CustomNotification({
					type: Notification.type.error,
					message: Notification.message.error,
					description: 'Hubo un problema actualizando los recursos',
				});
				console.log('error response: ', error);
			});
	};

	const handleGetCommunes = async (region) => {
		console.log('commune by region: ', region);
		new Service().getCommunesByRegion(region).then((response) => {
			const mapCommunes = response.map((iterator) => {
				return { label: capitalizeWords(iterator), value: capitalizeWords(iterator) };
			});
			setCommunesOptiones([...mapCommunes]);
		});
	};

	if (loading) return <Loading />;

	if (error) return 'No existe el registro';

	return (
		<div className='pharmacy-locals-details-container'>
			<Row justify={'center'} className="own-pharmacy-locals-details-page">
				<Col span={22}>
					<h1>{data?.pharmacy + ' - ' + data?.code_local}</h1>
					<Link to={checkRol(data?.pharmacy)}>Volver a sucursales</Link>

					<CustomCard>
						<PharmacyLocalForm
							onFinish={handleOnFinish}
							data={data}
							regionOptions={regionOptions}
							communesOptiones={communesOptiones}
							getCommunes={handleGetCommunes}
						/>
					</CustomCard>

					{/* {mercadoPagoData && (
						<>
							<CustomCard>
								<MercadoPagoIntegration mercadoPagoData={mercadoPagoData} name_local={nameLocal} />
							</CustomCard>
						</>
					)} */}
				</Col>
			</Row>
		</div>
	);
}
